import React from 'react'
import { Link } from 'react-router-dom'
import MessageUtils from '../../util/MessageUtils'
import './ButtonLink.css'

// Link that looks like a button
const ButtonLinkUI = ({to, label, messageList, labelKey, args, disabled, transparent}) =>
  <Link to={disabled ? '#' : to} className={`w_btn_link ${transparent ? 'transparent' : ''} ${disabled ? 'disabled' : ''}`} >
    {
      label &&
      <React.Fragment>{label}</React.Fragment>
    }
    {
      !label &&
      <React.Fragment>
        {MessageUtils.getMessageValue(messageList, labelKey, args)}
      </React.Fragment>
    }
  </Link>

export default ButtonLinkUI
